import { render, staticRenderFns } from "./DnaLayout.vue?vue&type=template&id=b43e5dba&"
import script from "./DnaLayout.vue?vue&type=script&lang=js&"
export * from "./DnaLayout.vue?vue&type=script&lang=js&"
import style0 from "./DnaLayout.vue?vue&type=style&index=0&id=b43e5dba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports